// eslint
/* global cast */

export default class Analytic {
    /**
     * Analytic constructor
     * @param {Object} options
     * @param {Logger} logger
     */
    constructor(options, logger) {
        this.context = cast.framework.CastReceiverContext.getInstance();
        this.playerManager = this.context.getPlayerManager();
        const defaultOptions = {
            title: null
        };
        this.options = Object.assign(defaultOptions, options);
        this.logger = logger;
        this.metadata = new cast.framework.messages.GenericMediaMetadata();
    }

    initEvents() {
        return;
    }

    setCustomData() {
        return;
    }

    sendAction() {
        return;
    }

    mediaFinishedEvent() {
        return;
    }

    mediaStatusEvent() {
        return;
    }

    mediaSeekEvent() {
        return;
    }
}
